"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createSingleActionHandlers;

var _Status = require("../../models/Status");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function createSingleActionHandlers(_ref) {
  var _ref2;

  var actionHandler = _ref.actionHandler,
      statusKey = _ref.statusKey,
      dataKey = _ref.dataKey,
      transparentStatus = _ref.transparentStatus,
      saveKeys = _ref.saveKeys;
  return _ref2 = {}, _defineProperty(_ref2, actionHandler, function (state, action) {
    var status = transparentStatus ? new _Status.Status(_Status.States.LOADING | _Status.States.NORMAL) : new _Status.Status(_Status.States.LOADING);
    return _objectSpread({}, state, _defineProperty({}, statusKey, status));
  }), _defineProperty(_ref2, actionHandler + '_SUCCESS', function (state, action) {
    if (dataKey) {
      var _objectSpread3;

      return _objectSpread({}, state, (_objectSpread3 = {}, _defineProperty(_objectSpread3, dataKey, action.payload.data), _defineProperty(_objectSpread3, statusKey, new _Status.Status(_Status.States.NORMAL)), _objectSpread3));
    }

    var newState = _objectSpread({}, state, {}, action.payload.data, _defineProperty({}, statusKey, new _Status.Status(_Status.States.NORMAL)));

    if (saveKeys) {
      saveKeys.forEach(function (key, index) {
        newState[key] = state[key];
      });
    }

    return newState;
  }), _defineProperty(_ref2, actionHandler + '_ERROR', function (state, action) {
    return _objectSpread({}, state, _defineProperty({}, statusKey, new _Status.Status(_Status.States.ERROR)));
  }), _ref2;
}